<template>
    <div class="wrap-input" :class="customClass">
        <div class="input-box">
            <input type="text"
                    v-model="content"
                    class="input-field"
                    autocomplete="off"
                    :placeholder="placeholder"
                    :id="id"
                    @input="onChange()"
                    @focus="onFocus(true)"
                    @blur="onFocus(false)"
                    @keyup.enter="onClickSearch()"/>
            <div class="clear-box" v-if="content">
                <img @click="clearcontent()" src="../../../../assets/new/icon/ic-round-close.png"/>
            </div>
            <button class="button-search" @click="onClickSearch()">
                <img src="@/assets/icon/ic-search.svg"/>
            </button>
        </div>
        <div class="top-search" v-show="showTopSearch">
            <div class="top-search-content">
                <div v-if="suggestionList.length == 0">
                    <div class="search-history" v-if="searchHistoryList.length > 0">
                        <div class="search-history-title">
                            <div>ประวัติการค้นหา</div>
                            <div class="search-history-delete" @click="deleteSearchHistory()">
                                <div>ล้าง</div>
                                <img src="../../../../assets/new/icon/ic-fluent-delete-2x.png"/>
                            </div>
                        </div>
                        <div v-for="j in searchHistoryList" :key="j.value" class="item-search-history">
                            <div @click="clickContent(j)">
                                {{ j }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="suggestion">
                        <div v-for="k in suggestionList" :key="k.value" class="itme">
                            <div @click="clickContent(k)">
                                {{ k }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-search-content"></div>
                <div>{{topSearchTxt}}</div>
                <div class="top-search-item">
                    <div v-for="i in topSearch" :key="i.value"
                        class="itme">
                        <div @click="clickContent(i)">
                            {{i}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {string} addClass (optional) Add css class
 * Event
 * @event onChange Filter and validate.
 */
import Account from '@/helper/AccountHelper';
import AccountMixin from '@/mixin/AccountMixin';
import B2bHistory from '@/core/History/service/B2bHistory';
export default {
    name: 'SearchTopBar',
    mixins: [AccountMixin],
    props: {
        //v-model
        value: String,
        //props
        inputId: String,
        inputLbl: String,
        topSearchTxt: String,
        addClass: String,
    },
    data: function () {
        return {
            id: '',
            label: '',
            placeholder: '',
            content: this.value,
            customClass: '',
            focusText: false,
            topSearch: null,
            showTopSearch: false,
            searchHistoryList: [],
            suggestionList: [],
            isLoadedSuggestion: false,
            isLoadeddeleteSearch: false
        };
    },
    watch:{
        value:function(val){
            this.content = val
        }
    },
    mounted: function () {
        this.id = this.inputId;
        this.placeholder = this.inputLbl;
        this.customClass = this.addClass || '';
        if(this.topSearch == null) {
            this.getTopSearch()
        }
        this.content = this.$route.params.keyword
    },
    created: function() {
        this.blobConfig = Account.getCacheBlob()
    },
    methods: {
        onChange: function () {
            var result = this.content;

            if (this.content == null || this.content == '' || /^\s*$/.test(this.content)) {
                return;
            }
            //Remove restrict character.
            result = result.replace(Vue.RegExp.emoji, '');

            this.content = result;
            setTimeout(() => {
                if (this.content == result) {
                    this.suggestion(result)
                }
            }, 1000);
        },
        onFocus: function(focus) {
            this.focusText = focus;
            if (focus) {
                this.showTopSearch = focus;
                if(this.isLogin) {
                    this.getSearchHistory()
                }
            } else {
                setTimeout(() => {
                    this.showTopSearch = false;
                    this.searchHistoryList = [];
                }, 300);
            }
        },
        getTopSearch: function() {
            this.topSearch = Account.getCacheCustom('searchlist')
        },
        onClickSearch: function() {
            if (this.content == null || this.content == '' || /^\s*$/.test(this.content)) {
                this.showTopSearch = false;
                return;
            }
            this.$router.push(`/search/${encodeURIComponent(this.content)}`)
        },
        clickContent: function(item) {
            this.content = item
            this.onClickSearch();
        },
        clearcontent: function () {
            this.content = '';
            this.showTopSearch = false
        },
        getSearchHistory: function() {
            let params = {
                top: 10,
                group: true,
                sort: true
            }
            B2bHistory.apiSearchHistory(params)
                .subscribe((res) => {
                    console.log(res)
                    this.searchHistoryList = res
                }, (err) => {
                    console.log(err)
                });
        },
        suggestion: function(content) {
            if (content == '') {
                this.suggestionList = []
                return ;
            }
            if (this.isLoadedSuggestion) return ;
            this.isLoadedSuggestion = true;
            let params = {
                config: this.blobConfig.campaign_list_config,
                q: content,
                top: 10
            }
            B2bHistory.getSuggestion(params).subscribe((res) => {
                    this.isLoadedSuggestion = false
                    this.suggestionList = res
                },
                (err) => {
                    this.isLoadedSuggestion = false
                    console.log(err)
                });
        },
        deleteSearchHistory: function() {
            if (this.isLoadeddeleteSearch) return ;
            this.isLoadeddeleteSearch = true;
            let params = {
                token: Account.getToken()
            }

            B2bHistory.deleteSearchHistory(params).subscribe((res) => {
                    this.isLoadeddeleteSearch = false
                    console.log(res)
                },
                (err) => {
                    this.isLoadeddeleteSearch = false
                    console.log(err)
                });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "./SearchTopBar.scss";
.wrap-input {
    @extend %input-base;
    @include mobile {
        display: none;
    }
}
</style>
